import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function PopularComics() {
  const popularComics = comics.filter((c) => c.popular).sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              人气热门排行
            </h2>
            <p className="text-sm text-foreground-600 mt-2">千万读者共同选择的热门韩漫</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {popularComics.map((comic, index) => (
            <div key={comic.id} className="relative">
              <span className="absolute -top-2 -left-2 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                {index + 1}
              </span>
              <ComicCard {...comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}